export const useStoreStream = defineStore('StoreStream', {
    state: () => ({
        stream: null,
        chapters: null,
        timeout: null,
        error: null,
        errorChapters: null,
    }),
    actions: {
        async getStream(streamSlug) {
            this.error = null;
            this.stream = null;
            ({stream: this.stream, error: this.error} = await useEntityStream().get(streamSlug));
        },
        async getChapters(streamSlug) {
            this.clearTimeout();
            this.errorChapters = null;
            let filter = {
                paginate: {
                    auto: false,
                },
                fields: {
                    stream_slug: streamSlug,
                },
            };
            ({chapters: this.chapters, error: this.errorChapters} = await useQueryStreamChapters().get(filter));
            if (this.errorChapters) console.log('Error getting chapters.', this.errorChapters);
            this.timeout = setTimeout(() => {
                this.getChapters(streamSlug);
            }, 15000);
        },
        stopChapters() {
            this.clearTimeout();
        },
        clearTimeout() {
            if (!this.timeout) return;
            clearTimeout(this.timeout);
            this.timeout = null;
        },
        refreshStream() {
            const $config = useRuntimeConfig();
            if ($config.public.stage === 'dev') console.log('Refreshing stream...');
            if (this.stream && this.stream?.id_stream_play && this.stream?.stream_slug)
                this.getStream(this.stream?.stream_slug);
        },
    },
    getters: {
        chaptersByDay() {
            if (!this.chapters) return null;
            let minDateTime = new Date();
            minDateTime.setHours(minDateTime.getHours() - 72); // Avoid serving chapters from previous event
            let filtered = this.chapters.filter((chapter) => {
                return chapter.stream_chapter_starts.getTime() > minDateTime.getTime();
            });
            const weekday = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
            let days = filtered.reduce((ac, a) => {
                let key = weekday[a.stream_chapter_starts.getDay()];
                ac[key] = (ac[key] || []).concat(a);
                return ac;
            }, {});
            return Object.keys(days).map((day) => {
                return {
                    day,
                    chapters: days[day],
                };
            });
        },
        chapterNow() {
            if (!this.chapters) return null;
            let minDateTime = new Date();
            minDateTime.setHours(minDateTime.getHours() - 8);
            let maxDateTime = new Date();
            maxDateTime.setHours(maxDateTime.getHours() + 8);
            let filtered = this.chapters.filter((chapter) => {
                return (
                    chapter.stream_chapter_starts.getTime() < new Date().getTime() &&
                    chapter.stream_chapter_starts.getTime() > minDateTime.getTime() &&
                    chapter.stream_chapter_starts.getTime() < maxDateTime.getTime()
                );
            });
            if (!filtered?.length) return null;
            return filtered.slice(-1)[0];
        },
        chapterNext() {
            if (!this.chapters) return null;
            let minDateTime = new Date();
            minDateTime.setHours(minDateTime.getHours() - 8);
            let maxDateTime = new Date();
            maxDateTime.setHours(maxDateTime.getHours() + 8);
            let filtered = this.chapters.filter((chapter) => {
                return (
                    chapter.stream_chapter_starts.getTime() > new Date().getTime() &&
                    chapter.stream_chapter_starts.getTime() > minDateTime.getTime() &&
                    chapter.stream_chapter_starts.getTime() < maxDateTime.getTime()
                );
            });
            if (!filtered?.length) return null;
            return filtered[0];
        },
    },
});
